export const downloadLinkId = 'download-link';
export const emptyHiddenInputId = 'empty-hidden-input-id';
export const formTemplateBuilderScrollboxId = 'form-template-builder-scrollbox';
export const pageStepsId = 'form-steps';
export const scannerDropDownsWrap = 'scannerDropDownsWrap';
